import { useQuery } from 'react-query';

import { axios } from 'lib';

const getSupplierRates = (frameworkAgreementId, lotId, facId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/rates/suppliers/${facId}`
  );
};

export const useSupplierRates = (frameworkAgreementId, lotId, facId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-setup-lots-${lotId}-rates-suppliers-${facId}`,
    () => getSupplierRates(frameworkAgreementId, lotId, facId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
